import providersSaga from './providers.saga';

export default providersSaga;
